import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_delete_invoicing_rule_template_exceptionService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { rule_id?: string, project_id?: number, exception?: string, id?: string }): Promise<{ exception_id?: string }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

